import CircularProgress from '@mui/material/CircularProgress';
function Spinner({...props}) {
    return (
        <CircularProgress {...props}/>
    );

}
export default Spinner;